import { render, staticRenderFns } from "./SaveIcon.vue?vue&type=template&id=6c6c86f0&scoped=true"
var script = {}
import style0 from "./SaveIcon.vue?vue&type=style&index=0&id=6c6c86f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6c86f0",
  null
  
)

export default component.exports